import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    startDate: '',
    endDate: '',
    size: 20,
  },
};

const shopInitialState = {
  list: null,
  loadStatus: 0,
};

const analysisMasterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'retail',
    startDate: '',
    endDate: '',
    size: 20,
  },
};

const performanceInitialState = {
  todayAmount: 0,
  yesterdayAmount: 0,
  weekAmount: 0,
  monAmount: 0,
  todayWriteOff: 0,
  yesterdayWriteOff: 0,
  weekWriteOff: 0,
  monWriteOff: 5,
  loadStatus: 0,
};

function performanceReducer(state = performanceInitialState, action) {
  switch (action.type) {
    case 'LOAD_MY_PERFORMANCE': {
      return {
        ...performanceInitialState,
        loadStatus: 1,
      };
    }

    case 'LOAD_MY_PERFORMANCE_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const data = action.data;

      return {
        ...state,
        ...data,
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function analysitMasterReducer(state = analysisMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_ANALYSIS_ORDER_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_ANALYSIS_ORDER_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list;

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_RECORD_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_RECORD_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list;

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function shopReducer(state = shopInitialState, action) {
  switch (action.type) {
    case 'LOAD_AR_SHOP_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }
    case 'LOAD_AR_SHOP_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(shop => {
        return {
          label: `${shop.storeName}（${shop.channelId}）`,
          value: shop.channelId,
        };
      });

      return {
        ...state,
        loadStatus: 2,
        list: list,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: masterReducer,
  shop: shopReducer,
  analysisMaster: analysitMasterReducer,
  performance: performanceReducer,
});
